<template>
  <b-modal ref="modal-center" centered body-class="pb-2" footer-class="d-flex">
    <!--HEADER MODAL -->
    <template v-slot:modal-header>
      <div class="row ml-0">
        <!-- logo mineduc-->
        <div class="logo col-3 pl-0 mt-n3">
          <a href="https://www.mineduc.cl/" target="_blank">
            <img
              class="img-fluid pr-lg-4"
              src="@/assets/img/logo-tope-subesup-mineduc3.png"
              alt="Ministerio de Educación"
            />
          </a>
        </div>

        <div class="col-12 offset-4 mt-n3 pl-3">
          <router-link :to="{name:'Home'}">
            <img
              src="@/assets/img/logo_acceso2.svg"
              class="logo-acceso img-fluid w-25"
              alt="logo ACCESO a la Educación Superior"
            />
          </router-link>
        </div>
      </div>
      <button type="button" class="close" @click="hideModal">
        <span aria-hidden="true">×</span>
      </button>
    </template>
    <!--BODY MODAL -->
    <form>
      <InputRutWrapper ref="rut" v-model="form.run" />
      <InputTextWraper
        id="nombre"
        v-model="form.nombre"
        tipo="text"
        placeholder="Nombre Completo"
        :estado="tieneError('nombre')"
        :mensajeError="mensajeError('nombre')"
        @keyup="validarNombre"
      />
      <p class="mt-3 mb-1">Contactarme por:</p>
      <div class="input-group mb-3">
        <b-form-checkbox-group
          v-model="form.mediosContacto"
          :options="options"
          :state="stateMedios"
          name="checkbox-contactos"
          size="sm"
          @change="validarMediosContacto"
        ></b-form-checkbox-group>
        <b-form-invalid-feedback
          :state="stateMedios"
        >Debe seleccionar al menos un medio de contacto.</b-form-invalid-feedback>
      </div>
      <InputTextWraper
        id="correo"
        v-model="form.mail"
        tipo="email"
        placeholder="Correo Electrónico"
        :estado="tieneError('correo')"
        :mensajeError="mensajeError('correo')"
        :maxlength="100"
        @keyup="validarCorreo"
        :deshabilitar="!form.mediosContacto.includes('EMAIL')"
      />
      <InputTextWraper
        id="telefono"
        v-model="form.telefono"
        tipo="text"
        placeholder="Teléfono Móvil"
        :estado="tieneError('telefono')"
        :mensajeError="mensajeError('telefono')"
        :maxlength="8"
        @keyup="validarTelefono"
        :deshabilitar="!(form.mediosContacto.includes('TELEFONO') || form.mediosContacto.includes('WHATSAPP'))"
      />
      <div class="input-group" v-if="datosContacto.listadoSedes">
        <b-form-select v-model="form.sedeSeleccionada" class="form-control" @change="validarSede">
          <option disabled value="null">- Seleccione una Sede -</option>
          <option
            v-for="s in listadoSedes"
            :key="s.codigoSede"
            :value="s.codigoSede"
          >{{`${s.region}: ${s.nombre}`}}</option>
        </b-form-select>
        <b-form-invalid-feedback :state="stateSede">Debe seleccionar una sede de contacto.</b-form-invalid-feedback>
      </div>
      <br />
      <div class="input-group">
        <b-form-checkbox
          v-model="checkTerminos"
          name="checkTerminos"
          size="sm"
          @change="validarTerminosYCondiciones"
        >
          <strong>
            Estoy de acuerdo con los
            <a
              href="https://acceso.mineduc.cl/wp-content/uploads/2020/07/TERMINOS_Y_CONDICIONES_USO_WEB_ACCESO.pdf"
              target="_blank"
            >términos y condiciones</a> de uso de información de
            <a href="https://acceso.mineduc.cl/">acceso.mineduc.cl</a>
          </strong>
        </b-form-checkbox>
        <b-form-invalid-feedback :state="stateTerminos">Debe aceptar los términos y condiciones.</b-form-invalid-feedback>
      </div>
    </form>
    <!--FOOTER MODAL-->
    <template v-slot:modal-footer>
      <div class="col px-0">
        <InvisibleRecaptcha
          id="input-Contacto"
          data-test="button-solicitar-simulacion"
          :sitekey="siteKey"
          :validate="validarCampos"
          :callback="enviarCorreo"
          theme="light"
          class="btn btn-negro w-100 rounded-0 enviar"
          :disabled="false"
          type="button"
        >Enviar</InvisibleRecaptcha>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ApiUniversidades from "@/services/ApiUniversidades";
import {
  MensajesDeRespuesta,
  MensajesDeCarga,
} from "@/utils/BusesDeEventos.js";
import InputTextWraper from "@/components/generales/modales/InputTextWrapper";
import InputRutWrapper from "@/components/generales/modales/InputRutWrapper";
import ManejoErrores from "@/mixins/manejoErrores";
import { validacion } from "@/utils/ValidacionGenerica";
import InvisibleRecaptcha from "@/components/recaptcha/InvisibleRecaptcha";
import { EventBus } from "@/assets/js/EventBus";
import { mapActions, mapGetters } from "vuex";
import ApiTecnicoProf from "@/services/ApiTecnicoProf";
export default {
  name: "ContactenmeTP",
  components: {
    InputTextWraper,
    InputRutWrapper,
    InvisibleRecaptcha,
  },
  props: {
    datosContacto: { type: Object },
  },
  mixins: [ManejoErrores],
  data() {
    return {
      form: {
        run: "",
        nombre: "",
        mail: "",
        telefono: "",
        mediosContacto: [],
        sedeSeleccionada: null,
      },
      config: {
        headers: {},
      },
      options: [
        { text: "Correo Electrónico", value: "EMAIL" },
        { text: "Llamada Telefónica", value: "TELEFONO" },
        { text: "Whatsapp", value: "WHATSAPP" },
      ],
      checkTerminos: false,
      stateTerminos: null,
      stateMedios: null,
      stateSede: null,
      siteKey: RECAPTCHA_PUBLIC_KEY,
    };
  },
  beforeCreate: async function () {
    EventBus.$on("verifyCaptcha", (token) => {
      this.enviarCorreo(token);
    });
  },
  computed: {
    ...mapGetters(["getBotonCaptcha"]),
    listadoSedes() {
      if (this.datosContacto.listadoSedes) {
        return this.datosContacto.listadoSedes;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions(["setBotonCaptcha"]),
    validarCampos() {
      MensajesDeCarga.$emit("cargar");
      this.setBotonCaptcha("MODAL_CORREO_TP");
      this.modificado = ["nombre", "telefono", "correo"];
      let valido = [
        this.validarRun(),
        this.validarNombre(),
        this.validarMediosContacto(this.form.mediosContacto),
        this.validarSede(),
        this.validarTerminosYCondiciones(this.checkTerminos),
      ];
      let validado = true;
      if (valido.includes(false)) {
        validado = false;
        MensajesDeCarga.$emit("cargado");
      }
      return validado;
    },
    enviarCorreo(recaptchaToken) {
      MensajesDeCarga.$emit("cargar");
      if (recaptchaToken && this.getBotonCaptcha === "MODAL_CORREO_TP") {
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken,
        };
        this.onSubmit();
      } else {
        MensajesDeCarga.$emit("cargado");
      }
    },
    valorCodigoSede() {
      if (
        this.datosContacto.codigoSede !== null ||
        this.form.sedeSeleccionada
      ) {
        return this.datosContacto.codigoSede !== null
          ? this.datosContacto.codigoSede
          : this.form.sedeSeleccionada;
      } else {
        return null;
      }
    },
    async onSubmit() {
      let run = this.runFormateado(this.form.run);
      let datos = {
        codigoCarrera: this.datosContacto.codigoCarrera
          ? this.datosContacto.codigoCarrera
          : null,
        codigoIntitucion: this.datosContacto.codigoIntitucion,
        codigoSede: this.valorCodigoSede(),
        formaContacto: this.form.mediosContacto,
        mail: this.form.mediosContacto.includes("EMAIL")
          ? this.form.mail
          : null,
        pasaporte:
          this.$refs.rut.getTipoDocumento() === "PASAPORTE"
            ? this.form.run
            : null,
        run: run,
        nombre: this.form.nombre,
        telefono: this.form.mediosContacto.includes("TELEFONO")
          ? this.form.telefono
          : null,
        whatsapp: this.form.mediosContacto.includes("WHATSAPP")
          ? this.form.telefono
          : null,
      };
      this.eliminarNull(datos);
      //console.log(datos);
      let respuesta = await ApiTecnicoProf.enviarCorreoContacto(
        datos,
        this.config
      );
      if (respuesta === "") {
        this.hideModal();
        this.mostrarMensajeExito();
        this.config.params = {};
      }
      this.setBotonCaptcha("");
      MensajesDeCarga.$emit("cargado");
    },
    eliminarNull(objeto) {
      let llaves = Object.keys(objeto);
      for (let llave of llaves) {
        if (objeto[llave] === null || objeto[llave] === undefined) {
          delete objeto[llave];
        }
      }
      return objeto;
    },
    validarRun() {
      return this.$refs.rut.validacionRun();
    },
    validarSede() {
      let flag = true;
      if (this.datosContacto.listadoSedes && !this.form.sedeSeleccionada) {
        flag = false;
        this.stateSede = false;
      } else {
        flag = true;
        this.stateSede = null;
      }
      return flag;
    },
    validarNombre() {
      let flag = true;
      this.limpiarError("nombre");
      if (this.form.nombre.length < 1) {
        flag = false;
        this.guardarError("nombre", "Debe indicar nombre");
      } else if (validacion("", this.form.nombre, "^[a-zA-Z'-\\s]*$")) {
        flag = false;
        this.guardarError("nombre", "Debe indicar nombre valido");
      }
      return flag;
    },
    validarMediosContacto(val) {
      let flag = true;
      if (val.length >= 1) {
        this.stateMedios = null;
        let flagTel = true;
        let flagEm = true;
        if (val.includes("TELEFONO") || val.includes("WHATSAPP")) {
          flagTel = this.validarTelefono();
        } else {
          this.form.telefono = "";
          this.limpiarError("telefono");
        }

        if (val.includes("EMAIL")) {
          flagEm = this.validarCorreo();
        } else {
          this.form.mail = "";
          this.limpiarError("correo");
        }

        flag = flagTel && flagEm ? true : false;
      } else {
        flag = false;
        this.stateMedios = false;
        this.limpiarError("telefono");
        this.limpiarError("correo");
      }
      return flag;
    },
    validarCorreo() {
      let flag = true;
      this.limpiarError("correo");
      if (this.form.mail.length < 1) {
        flag = false;
        this.guardarError("correo", "Debe indicar un correo electrónico");
      } else if (validacion("CORREO", this.form.mail)) {
        flag = false;
        this.guardarError(
          "correo",
          "Debe indicar un correo electrónico valido"
        );
      }
      return flag;
    },
    validarTelefono() {
      let flag = true;
      this.limpiarError("telefono");
      if (this.form.telefono.length < 1) {
        flag = false;
        this.guardarError("telefono", "Debe indicar un número telefónico");
      } else if (validacion("NUMERICO", this.form.telefono)) {
        flag = false;
        this.guardarError(
          "telefono",
          "Debe indicar un número telefónico valido"
        );
      }
      return flag;
    },
    validarTerminosYCondiciones(val) {
      if (val) {
        this.stateTerminos = null;
      } else {
        this.stateTerminos = false;
      }
      return this.checkTerminos;
    },
    runFormateado(valor) {
      let rut;
      if (this.$refs.rut.getTipoDocumento() === "RUT") {
        let runSeparado = this.$refs.rut.separarRun(valor);
        rut = `${runSeparado.run}-${runSeparado.digitoVerificador}`;
      } else {
        rut = null;
      }
      return rut;
    },
    showModal() {
      this.$refs["modal-center"].show();
    },
    hideModal() {
      this.$refs["modal-center"].hide();
    },
    mostrarMensajeExito() {
      MensajesDeRespuesta.$emit("respuestaEnvio");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/modales/ContactameTP.vue